export const getEmployeeMasterList = state => {
    return state.list
}

export const getEmployeeMasterDataProps = state => {
    return state.props
}

export const getEmployeeProductionStageList = state => {
    return state.allocated_production_stage
}


// WEBPACK FOOTER //
// ./src/store/modules/employee/getters.js